export const hasGmailModifyScope = (scopes: unknown): boolean => {
  if (Array.isArray(scopes)) {
    return scopes.some((scope) => String(scope).includes('gmail.modify'));
  }
  if (typeof scopes === 'string') {
    return scopes.includes('gmail.modify');
  }
  return false;
};

export const toGoogleAuthList = <T = Record<string, unknown>>(raw: unknown): T[] => {
  if (Array.isArray(raw)) {
    return raw.filter(Boolean) as T[];
  }
  if (raw) {
    return [raw as T];
  }
  return [];
};

export const normalizeGoogleAccessToken = (token: unknown): string => {
  if (!token) return '';
  if (typeof token === 'string') {
    return token.replace(/^Bearer\s+/i, '').trim();
  }
  if (typeof token === 'object') {
    const record = token as { access_token?: unknown; accessToken?: unknown };
    return normalizeGoogleAccessToken(record.access_token || record.accessToken);
  }
  return '';
};

export const parseGoogleScopeList = (scopes: unknown): string[] => {
  if (Array.isArray(scopes)) {
    return scopes.map(String).map((scope) => scope.trim()).filter(Boolean);
  }
  if (typeof scopes === 'string') {
    return scopes.split(/[\s,]+/).map((scope) => scope.trim()).filter(Boolean);
  }
  return [];
};

export type GoogleMailAuth = {
  email?: string;
  googleId?: string;
  accessToken?: string;
  refreshToken?: string;
  scopes?: string[] | string;
  connectedDate?: string | Date;
};

export const resolveGoogleMailAuth = (raw: unknown): GoogleMailAuth | null => {
  const list = toGoogleAuthList<GoogleMailAuth>(raw);
  const matches = list.filter(
    (auth) =>
      hasGmailModifyScope(auth?.scopes) &&
      Boolean(auth?.email) &&
      Boolean(normalizeGoogleAccessToken(auth?.accessToken))
  );
  if (!matches.length) {
    return null;
  }

  const dated = [...matches].sort((a, b) => {
    const aTime = a.connectedDate ? new Date(a.connectedDate).getTime() : 0;
    const bTime = b.connectedDate ? new Date(b.connectedDate).getTime() : 0;
    return bTime - aTime;
  });
  if (dated[0]?.connectedDate) {
    return dated[0];
  }
  return matches[matches.length - 1];
};
